<template>
	<common-welcomebox
		card-type="dismiss"
		:title="greeting"
		:hide-button="true"
		@dismiss="dismiss({ key: 'WelcomeBack' })"
	>
		<p>
			We'd like to introduce you to the next major update of OptinMonster! With new workflows, new features,
			better performance and improved targeting, this update is sure to help you get more subscribers, leads and
			sales from your website!
		</p>
		<core-button
			:arrow="true"
			size="monster"
			color="green"
			:href="$urls.docs('optinmonster-plugin-2-0', 'WelcomeBackPluginV2')"
			target="_blank"
			rel="noopener"
		>
			Read the <span style="white-space: nowrap">OptinMonster 2.0 Guide</span>
		</core-button>
	</common-welcomebox>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
	computed: {
		...mapGetters(['userFirstName']),
		greeting() {
			let name = '';
			if (this.userFirstName) {
				name += ' ' + this.userFirstName;
			}

			return `Welcome back${name}!`;
		},
	},
	methods: {
		...mapMutations('dashboard', ['dismiss']),
	},
};
</script>
